import _classCallCheck from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/home/jenkins/workspace/AI\u5408\u89C4\u524D\u7AEF-\u6D4B\u8BD5/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import '../common/common.less';
import '@/captcha/slider/slider.less';
import './concat.less';
import { Dom, CommonCaptcha, clearAllPreventDefault, down, initConfig, destroyEvent } from '../common/common.js';
var TYPE = 'CONCAT';
function getTemplate(styleConfig) {
  return "\n    <div id=\"tianai-captcha\" class=\"tianai-captcha-slider tianai-captcha-concat\">\n    <div class=\"slider-tip\">\n        <span id=\"tianai-captcha-slider-move-track-font\" >\u62D6\u52A8\u6ED1\u5757\u5B8C\u6210\u62FC\u56FE</span>\n    </div>\n    <div class=\"content\">\n        <div class=\"tianai-captcha-slider-concat-img-div\" id=\"tianai-captcha-slider-concat-img-div\">\n            <img id=\"tianai-captcha-slider-concat-slider-img\" src=\"\" alt/>\n        </div>\n        <div class=\"tianai-captcha-slider-concat-bg-img\"></div>\n         <div class=\"tianai-captcha-tips\" id=\"tianai-captcha-tips\"></div>\n    </div>\n    <div class=\"slider-move\">\n        <div class=\"slider-move-track\">\n            <div id=\"tianai-captcha-slider-move-track-mask\"></div>\n            <div class=\"slider-move-shadow\"></div>\n        </div>\n        <div class=\"slider-move-btn\" id=\"tianai-captcha-slider-move-btn\">\n        </div>\n    </div>\n</div>\n    ";
}
var Concat = /*#__PURE__*/function (_CommonCaptcha) {
  function Concat(divId, styleConfig) {
    var _this;
    _classCallCheck(this, Concat);
    _this = _callSuper(this, Concat);
    _this.boxEl = Dom(divId);
    _this.styleConfig = styleConfig;
    _this.type = TYPE;
    _this.currentCaptchaData = {};
    return _this;
  }
  _inherits(Concat, _CommonCaptcha);
  return _createClass(Concat, [{
    key: "init",
    value: function init(captchaData, endCallback, loadSuccessCallback) {
      // 重载样式
      this.destroy();
      this.boxEl.append(getTemplate(this.styleConfig));
      this.el = this.boxEl.find('#tianai-captcha');
      this.loadStyle();
      // 按钮绑定事件
      this.el.find('#tianai-captcha-slider-move-btn').mousedown(down.bind(null, this));
      this.el.find('#tianai-captcha-slider-move-btn').touchstart(down.bind(null, this));
      clearAllPreventDefault(this.el);
      // 绑定全局
      window.currentCaptcha = this;
      // 载入验证码
      this.loadCaptchaForData(this, captchaData);
      this.endCallback = endCallback;
      if (loadSuccessCallback) {
        // 加载成功
        loadSuccessCallback(this);
      }
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy() {
      destroyEvent();
      var existsCaptchaEl = this.boxEl.children('#tianai-captcha');
      if (existsCaptchaEl) {
        existsCaptchaEl.remove();
      }
    }
  }, {
    key: "doMove",
    value: function doMove() {
      var moveX = this.currentCaptchaData.moveX;
      this.el.find('#tianai-captcha-slider-move-btn').css('transform', 'translate(' + moveX + 'px, 0px)');
      this.el.find('#tianai-captcha-slider-concat-img-div').css('background-position-x', moveX + 'px');
      this.el.find('#tianai-captcha-slider-move-track-mask').css('width', moveX + 'px');
    }
  }, {
    key: "loadStyle",
    value: function loadStyle() {
      var sliderImg = '';
      var moveTrackMaskBorderColor = '#00f4ab';
      var moveTrackMaskBgColor = '#a9ffe5';
      var styleConfig = this.styleConfig;
      if (styleConfig) {
        sliderImg = styleConfig.btnUrl;
        moveTrackMaskBgColor = styleConfig.moveTrackMaskBgColor;
        moveTrackMaskBorderColor = styleConfig.moveTrackMaskBorderColor;
      }
      this.el.find('.slider-move .slider-move-btn').css('background-image', 'url(' + sliderImg + ')');
      // this.el.find("#tianai-captcha-slider-move-track-font").text(title);
      this.el.find('#tianai-captcha-slider-move-track-mask').css('border-color', moveTrackMaskBorderColor);
      this.el.find('#tianai-captcha-slider-move-track-mask').css('background-color', moveTrackMaskBgColor);
    }
  }, {
    key: "loadCaptchaForData",
    value: function loadCaptchaForData(that, data) {
      var bgImg = that.el.find('.tianai-captcha-slider-concat-bg-img');
      var sliderImg = that.el.find('#tianai-captcha-slider-concat-img-div');
      bgImg.css('background-image', 'url(' + data.captcha.backgroundImage + ')');
      sliderImg.css('background-image', 'url(' + data.captcha.backgroundImage + ')');
      sliderImg.css('background-position', '0px 0px');
      var backgroundImageHeight = data.captcha.backgroundImageHeight;
      var height = (backgroundImageHeight - data.captcha.data.randomY) / backgroundImageHeight * 180;
      sliderImg.css('height', height + 'px');
      that.currentCaptchaData = initConfig(bgImg.width(), bgImg.height(), sliderImg.width(), sliderImg.height(), 300 - 63 + 5);
      that.currentCaptchaData.currentCaptchaId = data.id;
    }
  }]);
}(CommonCaptcha);
export default Concat;